export default __webpack_public_path__ + "static/media/profile_1.47d177e4.png";